export const QUERY_KEYS = {
  impactGroups: {
    list: ["impactGroups", "list"],
  },
};
